<template>
	<svg fill="currentColor" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m464 428-124.08-124.1a160.48 160.48 0 0 0 30.72-94.58c0-88.95-72.37-161.32-161.32-161.32s-161.32 72.37-161.32 161.32 72.37 161.32 161.32 161.32a160.48 160.48 0 0 0 94.58-30.72l124.1 124.08zm-254.68-108.31a110.38 110.38 0 1 1 110.37-110.37 110.5 110.5 0 0 1 -110.37 110.37z"/></svg>
</template>

<script>
export default {
	name: 'IconSearch',
};
</script>
